// extracted by mini-css-extract-plugin
module.exports = {"list":"VerticalList_list_rcTfn"};